module.exports = __webpack_public_path__ + "img/affitto.9d1b4bf.svg";